$(document).ready(function () {
  headerSticky();
  headerSubMenu();
  homepageCarousel();
  mobileMenu();
  homepageSlidersInit();
  productPageSlide();
  productPageQuantity();
  quoteSlide();
  reviewSlide();
  whyMedifyCadrTransiiton();
  readMore();
  blogPageSlidersInit();
  b2bPageProductSlidersInit();
  blogTitlesSameHeight();
  faqSearch();
  setTimeout(function(){
    clubShippingTitleHeight();
  }, 100)
});

$(window).resize(function () {
  homepageSlidersInit();
  blogTitlesSameHeight();
  setTimeout(function(){
    clubShippingTitleHeight();
  }, 100)
  $(".sub-menu").hide();
  $(".sub-menu-trigger").removeClass("sub-menu-trigger--open");
});

function headerSticky() {
  var topBannerHeight = $(".top-banner").length
    ? $(".top-banner").outerHeight()
    : 0;
  $(window).scroll(function () {
    var headerEl = $("header.header");
    var scroll = $(window).scrollTop();
    if (scroll > topBannerHeight) {
      headerEl.addClass("header--fixed");
      $('body').addClass("fixed-header");
    } else {
      headerEl.removeClass("header--fixed");
      $('body').removeClass("fixed-header");
    }
  });
}

function headerSubMenu() {
  $(".header__nav > li > a").hover(
    function () {
      const isDesktop = $(window).width() >= 1200;
      if (isDesktop && !$(this).hasClass("active")) {
        $(".header__nav > li > a.active").removeClass("active");
        $(this).addClass("active");
        $(".header__nav > li .sub-menu").fadeOut(250);
        $(this).siblings(".sub-menu").fadeIn(250);
      }
    },
    function () {
      const isDesktop = $(window).width() >= 1200;
      if (isDesktop && !$(this).siblings(".sub-menu").length) {
        $(this).removeClass("active");
      }
    }
  );
  $(".header").hover(
    function () {
      const isDesktop = $(window).width() >= 1200;
      if (isDesktop) {
        $(this).addClass("header--open");
      }
    },
    function () {
      const isDesktop = $(window).width() >= 1200;
      if (isDesktop) {
        $(".header__nav > li .sub-menu").fadeOut(250);
        $(".header__nav > li > a.active").removeClass("active");
        $(this).removeClass("header--open");
      }
    }
  );
  $(".header__nav .sub-menu-trigger").click(function (e) {
    const isDesktop = $(window).width() >= 1200;
    if (!isDesktop && $(this).siblings(".sub-menu").length) {
      e.preventDefault();
      if (!$(this).hasClass("sub-menu-trigger--open")) {
        $(".sub-menu-trigger").removeClass("sub-menu-trigger--open");
        $(".sub-menu").hide();
        $(this).addClass("sub-menu-trigger--open");
        $(this).siblings(".sub-menu").show();
      } else {
        $(".sub-menu-trigger").removeClass("sub-menu-trigger--open");
        $(".sub-menu").hide();
      }
    }
  });
}

function homepageCarousel() {
  $("#carousel").on("slide.bs.carousel", function (e) {
    $(".carousel__img").fadeOut();
    $($(".carousel__img")[e.to]).fadeIn();
  });
}

function mobileMenu() {
  $(".header__toggle-menu").click(function () {
    $(this).toggleClass("menu-open");
    $(".sub-menu").hide();
    $(".sub-menu-trigger").removeClass("sub-menu-trigger--open");
    $("header.header").toggleClass("header--menu-open");
    if ($(this).hasClass("menu-open")) {
      $(".header__nav").css("display", "flex").hide().slideDown();
    } else {
      $(".header__nav").slideUp();
      $(".sub-menu").slideUp();
    }
  });
}

function homepageSlidersInit() {
  const isMobile = $(window).width() < 768;
  if (isMobile) {
//     $(".products-wrapper").not(".slick-initialized").slick({
//       dots: true,
//       arrows: false,
//     });
    if(!$(".club-shipping__wrapper").hasClass('slick-initialized') && $('.club-shipping__wrapper') == 0) {
      $(".club-shipping__wrapper").slick({
        dots: true,
        arrows: false,
      }); 
    }
  } else {
//     if($('.products-wrapper').hasClass('slick-initialized')){
//       $(".products-wrapper").slick("unslick"); 
//     }
    
    if($('.club-shipping__wrapper').hasClass('slick-initialized')){
      $(".club-shipping__wrapper").slick("unslick");
    }
    
  }
}

function productPageSlide() {
  $("#js-product-slider-main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: "#js-product-slider-nav",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
        },
      },
    ],
  });
  $("#js-product-slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: "#js-product-slider-main",
    focusOnSelect: true,
    dots: false,
    arrows: false,
    centerMode: true,
    variableWidth: true,
  });
}

function quoteSlide() {
  $("#js-quote-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
  });
}
function reviewSlide() {
  $("#js-review-b2b-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });
}

function productPageQuantity() {
  var productQuantityInput = $("#js-product-quantity-input")[0];
  $("#js-product-quantity-add").click(function () {
    productQuantityInput.value = Number(productQuantityInput.value) + 1;
  });
  $("#js-product-quantity-subtract").click(function () {
    if (Number(productQuantityInput.value) > 1) {
      productQuantityInput.value -= 1;
    }
  });
}
function whyMedifyCadrTransiiton() {
  const $el = $(".cadr-medify__img-wrapper");
  if ($el.length) {
    $(window).scroll(function () {
      const elementTop = $el.offset().top;
      const elementHeight = $el.height();
      const screenTop = $(window).scrollTop();
      const screenHeight = $(window).height();
      const isElementCenterOnScreen =
        elementTop + elementHeight / 2 < screenTop + screenHeight / 2;
      if (isElementCenterOnScreen) {
        $el.addClass("cadr-medify__img-wrapper--animated");
      } else {
        $el.removeClass("cadr-medify__img-wrapper--animated");
      }
    });
  }
}

function readMore() {
  const maxLength = 322;
  $(".js-review-content").each(function () {
    var myStr = $(this).text();
    if ($.trim(myStr).length > maxLength) {
      var newStr =
        myStr.substring(0, maxLength) + '<span class="reviews__dots">...<span>';
      var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
      $(this).empty().html(newStr);
      $(this).append(
        ' <a href="javascript:void(0);" class="reviews__read-more">read more</a>'
      );
      $(this).append('<span class="reviews__more-text">' + removedStr);
    }
  });

  $(document).on("click", ".reviews__read-more", function () {
    $(this).parent(".js-review-content").find("span.reviews__dots").remove();
    $(this).siblings(".reviews__more-text").contents().unwrap();
    $(this).remove();
  });
}

function blogPageSlidersInit() {
  const isMobile = $(window).width() < 768;
  if (isMobile) {
    $(".posts-wrapper").not(".slick-initialized").slick({
      dots: true,
      arrows: false,
    });
  } else {
    $(".posts-wrapper.slick-initialized").slick("unslick");
  }
}

function b2bPageProductSlidersInit() {
  const isMobile = $(window).width() < 768;
  if (isMobile) {
    $("#js-products-slider").not(".slick-initialized").slick({
      dots: true,
      arrows: false,
    });
  } else {
    $("#js-products-slider.slick-initialized").slick("unslick");
  }
}
function blogTitlesSameHeight() {
  $(document).find(".blog__title").css({"height":"auto"});
  var largest = 0;

  $(document).find(".blog__title").each(function(){
    var findHeight = $(this).height();
    if(findHeight > largest){
      largest = findHeight;
    }  
  });

  $(document).find(".blog__title").css({"height":largest+"px"});

}

function faqSearch() {
  $('.faq-search__input').parent('form').on('submit', function(e) {
    e.preventDefault();
  });
  
  $('.faq-search__input').on('input', function() {
    let searchQuery = $(this).val().toLowerCase().trim() // get the current value of the input field.
    if (searchQuery === '') {
      $( ".faq-accordion .card" ).each(function() {
        $(this).show()
        $('.faq-accordion').show()
        $('.faq-search__nav-list a').show()
      });
    } else {
      $( ".faq-accordion .card" ).each(function() {
        $(this).hide()
        if ($(this).text().toLowerCase().indexOf(searchQuery) >= 0) {
          $(this).show()
        }

        // HIDE accordion container (with heading) when all cards are hidden: 
        let isAllCardsHidden = ($(this).css('display') == 'none');
        let accordionID = $(this).parents('.faq-accordion').attr('id')
        $(this).siblings().each(function() {
          if ($(this).css('display') !== 'none') {
            isAllCardsHidden = false
          }
        });
        if (isAllCardsHidden) {
          $(this).parents('.faq-accordion').hide()
          $('.faq-search__nav-list a[href="#' + accordionID +'"]').hide()
        } else {
          $('.faq-search__nav-list a[href="#' + accordionID +'"]').show()
          $(this).parents('.faq-accordion').show()
        }
      });
    }
  });
}

function clubShippingTitleHeight () {
  const heading = $(".club-shipping .club-shipping__heading");
  const headingWrapper = $(".club-shipping .club-shipping__heading-wrapper");
  var maxHeight = 0;
  heading.each(function(index, el) {
    if($(el).outerHeight() > maxHeight) {
      maxHeight = $(el).outerHeight();
    }
  })
  headingWrapper.css('min-height', maxHeight + 15 + 'px');
}

$(document).on("click", 'a[href^="#"]', function (event) {
 if (!event.target.getAttribute("href")) {
    return;
  }
  event.preventDefault();

  $("html, body").animate(
    {
      scrollTop:
      $($.attr(this, "href")).offset() ? $($.attr(this, "href")).offset().top - $(".header").outerHeight() : null,
    },
    800
  );
});

//# sourceMappingURL=app.js.map


$('#select-filter').on('change', function(){
  var productID = $(this).val();
  var selectedImg = $('option:selected', this).attr('data-image');
  $('.toggleForm').hide();
  console.log(productID);
  $('[data-product="'+productID+'"]').show();
  $('.select-filter__img').attr('src', selectedImg);
  var price = $('[data-product="'+productID+'"]').find('.rc_block__type--active').find('.rc_price').html();
  console.log("price", price + '__'+productID);
  $('[data-product="'+productID+'"]').find('.new-price.product-price').html(price);
  
  
})


$('.select-filter').on('change', '.product-single__variants', function(){
  console.log("hello");
  $('.select-filter').removeClass('active');
  $('.product-single__variants').removeClass('activeProduct');
  $(this).addClass('activeProduct');
  var variantPrice = $('option:selected', this).attr('data-variant-price');
  $(this).parents('.toggleForm').find('span.new-price.product-price').text(variantPrice);
  var subscriptionType =  $(this).parents('.toggleForm').find('.rc_block__type--active').find('.rc_price').text();
  setTimeout(function(){
    updatePrice();
  },300)
})

$('.toggleForm').on('change', '[name="purchase_type"]', function(){
  console.log("dd")
  var prieSubs = $(this).parents('.toggleForm').find('.rc_block__type--active').find('.rc_price').text();
  $(this).parents('.toggleForm').find('.product-price').text(prieSubs);
})

$(window).load(function(){
  setTimeout(function(){
    var price = $('.toggleForm:visible').find('.rc_block__type--active').find('.rc_price').html();
    $('.toggleForm:visible').find('span.new-price.product-price').html(price)
  },1000);
});

$(document).ready(function(){
  
  console.log($('.toggleForm:visible').find('.rc_block__type--active').find('.rc_price').html());
 
  
  $(document).on('change', '.product-single__variants', function(){
    var VAriantName = ($(this).find("option:selected").text()).trim();
    console.log(VAriantName);
    var toggleForm = $(this).parents('.toggleForm');
    var oneTime = toggleForm.find('.rc_radio__onetime');
    var onTimeBlock = toggleForm.find('.rc_block__type__onetime');
    var subscribeInput = toggleForm.find('.rc_radio__autodelive');
    var subscribeBlock = toggleForm.find('.rc_block__type__autodeliver');
    
    var option = $('option:selected', this),
        image = option.attr('data-variant-image'),
        selectedProduct = $(this).parents(".select-filter");
    	selectedProduct.find('.select-filter__img').attr('src', image);
    
    console.log(image);
    
    
//     if(VAriantName.includes("HEPA H14")){
//       oneTime.prop("checked", true);
//       oneTime.trigger('click');
//       setTimeout(function(){
//         var activeFormPrice = toggleForm.find('.rc_block__type--active').find('.rc_price').text();
//         $('.toggleForm:visible').find('.product-price').text(activeFormPrice);
//         }, 200)
//       subscribeBlock.hide();
//     }else{
//       subscribeBlock.show();
//        setTimeout(function(){
//          var activeFormPrice = toggleForm.find('.rc_block__type--active').find('.rc_price').text();
//          $('.toggleForm:visible').find('.product-price').text(activeFormPrice);
//        }, 200)
//     }
  });
})

$( window ).load(function() {
  setTimeout(function(){
    var subs = $('.toggleForm:visible').find('.rc_block__type--active').find('.rc_price').text();
    $('.toggleForm:visible').find('.product-price').text(subs);
  },200)
});

function updatePrice(){
  var subscriptionPrice = $('.activeProduct').parents('.toggleForm').find('.rc_block__type--active').find('.rc_price').html(); 
  
  $('.activeProduct').parents('.toggleForm').find('.product-price').text(subscriptionPrice);
}


function goToNext(){
  $('.slider').slick('slickNext');
}

function goSlidePrev(e){
  e.preventDefault();
  $('.slider').slick('slickPrev');
}

$(document).ready(function() {
  var $slider = $('.slider');
//   var $progressBar = $('.progress');
//   var $progressBarLabel = $( '.slider__label' );

//   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//     var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;

//     $progressBar
//     .css('background-size', calc + '% 100%')
//     .attr('aria-valuenow', calc );

//     $progressBarLabel.text( calc + '% completed' );
//   });

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrows: false,
    fade: true,
    cssEase: 'linear',
    swipe: false,
    adaptiveHeight: true
  });
  
  $slider.on("afterChange", function (event, slick, currentSlide){
    $slider.slick('refresh');
    $('html, body').scrollTop($('#bundleSlider').offset().top - 80);
  });
  
  
  $('.bundleType').on('click', function(e){
  	var type = $(this).attr("data-bundle-type");
    $('#bundleType').text(type);
    $('.perfectSolution').hide();
    $('[data-type-solution="'+type+'"]').show();
  })
  
  $('.sizeSelect').on('click', function(){
    var size = $(this).attr('data-size');
    $('.sizeType').hide();
    $('.size_'+size).show();
  });
  
  $('.build-product').on('click', function(){
    var houseType = $(this).attr('data-generated');
    $('.product-available').hide();
    $('.product-available.'+houseType).show();
    
    var totalPrice = '',
        totaOldPrice = 0,
        priceSingle = 0;
    
    if(houseType == '3_Bedroom') {
      $('select[data-productid="4515189555267"]').val('31921071816771').trigger('change');
    }else if(houseType == '3_Bedroom_Townhouse') {
      $('select[data-productid="4404392263747"]').val('31541955133507').trigger('change');
    }else if(houseType == '4_Bedroom') {
      $('select[data-productid="4515189555267"]').val('31921071816771').trigger('change');
      $('select[data-productid="4404392263747"]').val('31541955133507').trigger('change');
    }else if(houseType == '5_Bedroom') {
      $('select[data-productid="4404392263747"]').val('31541955133507').trigger('change');
    }else if(houseType == '6_Bedroom') {
      $('select[data-productid="4404392263747"]').val('31541955133507').trigger('change');
      $('select[data-productid="4321617150019"]').val('31233858961475').trigger('change');
    }
    
    $.each($(".product-available"), function(){ 
      if($(this).is(":visible")) {
        var selectedOption = $(this).find('[name="id"]').find('option:selected');
        var currentPrice = parseInt(selectedOption.attr('data-price'));
        var oldPrice = parseInt(selectedOption.attr('data-compare-price'));
        priceSingle = priceSingle + currentPrice;
        totaOldPrice = totaOldPrice + oldPrice;
      }

    });
    var currentPriceTotal = priceSingle;
    var odlPriceTotal = totaOldPrice;
    var bundleSaving = odlPriceTotal-currentPriceTotal;
    console.log(Shopify.formatMoney(bundleSaving, money_format));
    $('.bundles-step__price').html(Shopify.formatMoney(bundleSaving, money_format));
  


     
  });
  
  $('.addToCartBundle').on('click', function(e){
    e.preventDefault();
    var variantsArray = '';
    var lengthAvailable = $('.product-available').length;
    $.each($(".product-available"), function(index){
      var currentIndexLength = index+1;
      if($(this).is(":visible")) {
        var selectedOption = $(this).find('[name="id"]').find('option:selected');
        var variant = $(this).find('[name="id"]').val();
        if(variantsArray != '') {
        variantsArray = variantsArray + ','+variant; 
        }else{
          variantsArray = variant; 
        }
      }
      console.log(lengthAvailable, index);
      if(lengthAvailable == currentIndexLength) {
        addAllItems(variantsArray, 'checkount');
        console.log("hello");
      }
    });
   
  })
  
  $('.onSelectBundle').on('change', function(){
    var value = $(this).val();
    var option = $('option:selected', this),
        price = option.attr('data-price'),
        comparePrice = option.attr('data-compare-price'),
        priceConverted = option.attr('data-price-converted'),
        priceCompareConverted = option.attr('data-compare-price-converted'),
        image = option.attr('data-variant-image'),
        selectedProduct = $(this).parents(".single-product");
    
    selectedProduct.find('.priceAdjusted').html('<span class="single-product__old-price">'+priceCompareConverted+'</span> '+priceConverted);
    selectedProduct.find('.product-img').attr('src', image);
  })
  
  $(document).on('click', '.goToCheckout', function(e){
//     e.preventDefault();
//     window.location.href = "https://medifyair.com/checkout?discount=BUNDLE";	
  })
  
});

// ,swipe: false 


function addAllItems(array, typeEvnt){
	Shopify.queue = [];
	  var quantity = 0 ;
	  var newArray = array.split(',');
	  for (var i = 0; i < newArray.length; i++) {
	    product = newArray[i]
	    Shopify.queue.push({
	      variantId: product,
	    });
          }
	  Shopify.moveAlong = function() {
	  // If we still have requests in the queue, let's process the next one.
	  if (Shopify.queue.length) {
	    var request = Shopify.queue.shift();
	    var data = 'id='+ request.variantId + '&quantity=1'
	    $.ajax({
	      type: 'POST',
              url: '/cart/add.js',
	      dataType: 'json',
	      data: data,
	      success: function(res){
	        Shopify.moveAlong();
		    quantity += 1;
            if(quantity == newArray.length) {
              if(typeEvnt == 'checkount') {
                $('.addToCartBundle').hide();
                $('.goToCheckout').show();
              }else {
                window.location.href = "/cart";

              }
            }
	     },
             error: function(e){
	     // if it's not last one Move Along else update the cart number with the current quantity
		  if (Shopify.queue.length){
		    Shopify.moveAlong()
		  } else {
            console.log(e);
// 		    $('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
		  }
	      }
           });
        }
	 // If the queue is empty, we add 1 to cart
	else {
	  console.log("sdfsfsdf");
	 }
       };
    Shopify.moveAlong();
  };

  const sortSquareFootage = () => {
    let airWrapper = $('.air-purifiers-wrapper');
    airWrapper.find('.single-air').sort(function(a, b) {
      const aAux = parseInt(a.getAttribute("coverage").replace(",",""), 10);
      const bAux = parseInt(b.getAttribute("coverage").replace(",",""), 10);
        return +bAux - +aAux;
    })
    .appendTo(airWrapper);

    let filterWrapper = $('.filters-wrapper');
    filterWrapper.find('.single-filter').sort(function(a, b) {
      const aAux = parseInt(!!a.getAttribute("coverage").replace(",","") ? a.getAttribute("coverage").replace(",","") : 0, 10);
      const bAux = parseInt(!!b.getAttribute("coverage").replace(",","") ? b.getAttribute("coverage").replace(",","") : 0, 10);
      console.log(aAux, bAux);
        return +bAux - +aAux;
    })
    .appendTo(filterWrapper);
  }
  
  const sortCustomerRating = () => {
    console.log("sorting customer rating...");
    let airWrapper = $('.air-purifiers-wrapper');
    $('.air-purifiers-wrapper > div > div > div.single-product__content > div.single-product__rating.mobile-rating > div > div > div.standalone-bottomline > div.yotpo-bottomline.pull-left.star-clickable > span > span.sr-only').each((idx, el) => {
      const rating = el.textContent.split(" ")[0];
      console.log(rating);
      $(el).closest('.single-air').attr("rating", rating);
    })
    airWrapper.find('.single-air').sort(function(a, b) {
      const aAux = parseFloat(a.getAttribute("rating"));
      const bAux = parseFloat(b.getAttribute("rating"));
        return  +bAux - +aAux;
    })
    .appendTo(airWrapper);

    let filterWrapper = $('.filters-wrapper');
    $('.filters-wrapper > div > div > div > div > div > div > div > div.standalone-bottomline > div.yotpo-bottomline.pull-left.star-clickable > span > span.sr-only').each((idx, el) => {
      const rating = el.textContent.split(" ")[0];
      console.log(rating);
      $(el).closest('.single-filter').attr("rating", rating);
    })
    filterWrapper.find('.single-filter').sort(function(a, b) {
      const aAux = parseFloat(!!a.getAttribute("rating") ? a.getAttribute("rating") : 0);
      const bAux = parseFloat(!!b.getAttribute("rating") ? b.getAttribute("rating") : 0);
        return  +bAux - +aAux;
    })
    .appendTo(filterWrapper);
  }

  if(window.location.href.indexOf("square-footage") !== -1) {
    sortSquareFootage();
  }
  if(window.location.href.indexOf("customer-rating") !== -1) {
    setTimeout(() => {
      sortCustomerRating();
    }, 3000);
  }
// On Click on predefined proeuct
$(document).on('click', '.bundle_cart', function(e){
  e.preventDefault();
  var bundleItems = $(this).attr('data-bundle');
  _learnq.push(['track', 'Added to Cart', {productType: "Bundle Product"}]);
  addAllItems(bundleItems,'cart');
});



$('.sort-position').on('change', function(){
  setTimeout(() => {
    const isSquarFootage = window.location.href.indexOf("square-footage") !== -1;
    const isCustomerRating = window.location.href.indexOf("customer-rating") !== -1;
  
    if(!isSquarFootage && !isCustomerRating) {
      setTimeout(() => {
        window.location.reload(false);
      }, 500)
    } else {
      if (isSquarFootage){
        sortSquareFootage();
      } else {
        sortCustomerRating();
      }
    }
  }, 500)
 

})

// TAg filters on collection page
$('.filters__select:not(.sort-position)').on('change', function(e){
  var value = $(this).val();
  
  if(value == 'link') {
    var link = $('option:selected', this).attr('data-href');
    location.href=link;
    return;
  }
  
  var handle = collection.handle;
  var shopURL = collection.shopURL;
  
  var typeValue = $('.type-select').val();
  var applicationValue = $('.application-select').val();
  var areaValue = $('.area-select').val();
  var generateURL = '';
  
  var allSelect = typeValue+','+applicationValue+','+areaValue;
  
  
  var array = allSelect.split(',');
  var itemsProcessed = 0;
  array.forEach(function(item, index){
    itemsProcessed++;
    if(item != 0) {
      generateURL += item+'+'
    }
    if(itemsProcessed === array.length) {
      callback();
    }
  });
  function callback () {
    generateURL = generateURL.substring(0, generateURL.length - 1);
    window.location.href = shopURL+'/collections/'+handle+'/'+generateURL;
  }
  
})

$('.medify-banner-btn'). find('.btn-modify').on('click', function(e){
    var headerHeight = $('header.header').innerHeight();
    var offsetTop = $('#medify-school-form').offset().top;
    console.log(offsetTop);
    $('html, body').animate({
        scrollTop: offsetTop - headerHeight
    }, 500);
    e.preventDefault();
});
